import { isEditable } from "@testing-library/user-event/dist/utils";
import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Maps from "../../../components/Maps";
import { isMobileViewHook } from "../../../CustomHooks/isMobileViewHook";
import { AfterLoginHeader } from "../../../stories/AfterLoginHeader/AfterLoginHeader";
import Fonts from "../../../stories/assets/Fonts";
import FavouriteDetailCards from "../../../stories/FavouriteDetailCards/FavouriteDetailCards";
import classes from "./StudentFlowFavoritesDesktop.module.css";
import FavoritesMobile from "./FavoritesMobile";
import Colors from "../../../stories/assets/Colors";

const StudentFlowFavoritesDesktop = () => {
  const favCardsArr = [
    {
      firstName: "Mackenzie",
      lastName: "McDonald",
      description:
        "Professionally experienced knowledgeable coach of athletes from youths through collegiate level in tennisgiate level in tennis Professionally experienced knowledgeable coach of athletes from youths through collegiate level in tennisgiate level in tennis...",
      distance: "0.6 m away",
      rating: 5.0,
      price: 75,
      speciality: "Tennis",
    },
    {
      firstName: "Mackenzie",
      lastName: "McDonald",
      description:
        "Professionally experienced knowledgeable coach of athletes from youths through collegiate level in tennisgiate level in tennis...",
      distance: "0.6 m away",
      rating: 5.0,
      price: 75,
      speciality: "Tennis",
    },
    {
      firstName: "Mackenzie",
      lastName: "McDonald",
      description:
        "Professionally experienced knowledgeable coach of athletes from youths through collegiate level in tennisgiate level in tennis...",
      distance: "0.6 m away",
      rating: 5.0,
      price: 75,
      speciality: "Tennis",
    },
    {
      firstName: "Mackenzie",
      lastName: "McDonald",
      description:
        "Professionally experienced knowledgeable coach of athletes from youths through collegiate level in tennisgiate level in tennis...",
      distance: "0.6 m away",
      rating: 5.0,
      price: 75,
      speciality: "Tennis",
    },
    {
      firstName: "Mackenzie",
      lastName: "McDonald",
      description:
        "Professionally experienced knowledgeable coach of athletes from youths through collegiate level in tennisgiate level in tennis...",
      distance: "0.6 m away",
      rating: 5.0,
      price: 75,
      speciality: "Tennis",
    },
    {
      firstName: "Mackenzie",
      lastName: "McDonald",
      description:
        "Professionally experienced knowledgeable coach of athletes from youths through collegiate level in tennisgiate level in tennis...",
      distance: "0.6 m away",
      rating: 5.0,
      price: 75,
      speciality: "Tennis",
    },
    {
      firstName: "Mackenzie",
      lastName: "McDonald",
      description:
        "Professionally experienced knowledgeable coach of athletes from youths through collegiate level in tennisgiate level in tennis...",
      distance: "0.6 m away",
      rating: 5.0,
      price: 75,
      speciality: "Tennis",
    },
    {
      firstName: "Mackenzie",
      lastName: "McDonald",
      description:
        "Professionally experienced knowledgeable coach of athletes from youths through collegiate level in tennisgiate level in tennis...",
      distance: "0.6 m away",
      rating: 5.0,
      price: 75,
      speciality: "Tennis",
    },
    {
      firstName: "Mackenzie",
      lastName: "McDonald",
      description:
        "Professionally experienced knowledgeable coach of athletes from youths through collegiate level in tennisgiate level in tennis...",
      distance: "0.6 m away",
      rating: 5.0,
      price: 75,
      speciality: "Tennis",
    },
    {
      firstName: "Mackenzie",
      lastName: "McDonald",
      description:
        "Professionally experienced knowledgeable coach of athletes from youths through collegiate level in tennisgiate level in tennis...",
      distance: "0.6 m away",
      rating: 5.0,
      price: 75,
      speciality: "Tennis",
    },
    {
      firstName: "Mackenzie",
      lastName: "McDonald",
      description:
        "Professionally experienced knowledgeable coach of athletes from youths through collegiate level in tennisgiate level in tennis...",
      distance: "0.6 m away",
      rating: 5.0,
      price: 75,
      speciality: "Tennis",
    },
    {
      firstName: "Mackenzie",
      lastName: "McDonald",
      description:
        "Professionally experienced knowledgeable coach of athletes from youths through collegiate level in tennisgiate level in tennis...",
      distance: "0.6 m away",
      rating: 5.0,
      price: 75,
      speciality: "Tennis",
    },
    {
      firstName: "Mackenzie",
      lastName: "McDonald",
      description:
        "Professionally experienced knowledgeable coach of athletes from youths through collegiate level in tennisgiate level in tennis...",
      distance: "0.6 m away",
      rating: 5.0,
      price: 75,
      speciality: "Tennis",
    },
    {
      firstName: "Mackenzie",
      lastName: "McDonald",
      description:
        "Professionally experienced knowledgeable coach of athletes from youths through collegiate level in tennisgiate level in tennis...",
      distance: "0.6 m away",
      rating: 5.0,
      price: 75,
      speciality: "Tennis",
    },
    {
      firstName: "Mackenzie",
      lastName: "McDonald",
      description:
        "Professionally experienced knowledgeable coach of athletes from youths through collegiate level in tennisgiate level in tennis...",
      distance: "0.6 m away",
      rating: 5.0,
      price: 75,
      speciality: "Tennis",
    },
  ];

  const DesktopView = (
    <Container fluid className={`p-0 ${classes.container}`}>
      <div
        className={classes.header}
        style={{
          borderBottom: `1px solid ${Colors.neutralShadesOfWhisper}`,
          background: Colors.white,
        }}
      >
        <AfterLoginHeader showSearch customStyle={{ padding: "0px" }} />
      </div>
      <div className={classes.favContentBody}>
        <Row className="g-0">
          <Col md={6}>
            <div className={classes.favContainer}>
              <h1
                className={classes.marginBottom22Top26}
                style={{ ...Fonts.h3 }}
              >
                Favorites
              </h1>
              <div className={classes.overflowScroll}>
                {favCardsArr?.map((item, index) => (
                  <div className={classes.card}>
                    <FavouriteDetailCards data={item} />
                  </div>
                ))}
              </div>
            </div>
          </Col>
          <Col md={6} className={classes.mapColHeight}>
            <Maps type="map" location={{ lat: 32.715736, lng: -117.161087 }} />
          </Col>
        </Row>
      </div>
    </Container>
  );

  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    isMobileViewHook(setIsMobile, 992);
  }, []);

  return <div>{isMobile ? <FavoritesMobile /> : <>{DesktopView}</>}</div>;
};

export default StudentFlowFavoritesDesktop;
